export enum EPageBlock {
  NewPromo = 'new_promo',
  BankPromo = 'bank_promo',
  Beneficial = 'beneficial',
  PromoEnding = 'promo_ending',
  Categories = 'categories',
  LowMortgageRates = 'low_mortgage_rates',
  MortgagePrograms = 'mortgage_programs',
}
